export default __webpack_public_path__ + "static/media/find_your_voice.c9f533e3.png";